import React, { createContext, useContext, useState, useCallback, useMemo } from "react";

const CompareContext = createContext(null);
const STORAGE_KEY = "parkscanner_compare";

export function CompareProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    } catch {
      return [];
    }
  });

  const persist = (next) => {
    setItems(next);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  };

  const toggle = useCallback((park) => {
    setItems((prev) => {
      const exists = prev.find((p) => p.slug === park.slug);
      let next;
      if (exists) next = prev.filter((p) => p.slug !== park.slug);
      else if (prev.length >= 3) next = prev;
      else next = [...prev, { slug: park.slug, name: park.name, operator: park.operator, hero_image: park.hero_image }];
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      return next;
    });
  }, []);

  const remove = useCallback((slug) => {
    setItems((prev) => {
      const next = prev.filter((p) => p.slug !== slug);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      return next;
    });
  }, []);

  const clear = useCallback(() => persist([]), []);
  const has = useCallback((slug) => items.some((p) => p.slug === slug), [items]);

  const value = useMemo(() => ({ items, toggle, remove, clear, has }), [items, toggle, remove, clear, has]);
  return <CompareContext.Provider value={value}>{children}</CompareContext.Provider>;
}

export const useCompare = () => useContext(CompareContext);
